// Štítky napříč aplikacemi (jádro Labels, Nastavení → Štítky): seznam s barvami pro pole štítků a čipy. Načte se jednou,
// změnu (kanál core.labels) obnoví.
import { core } from './api';
import { events } from './events';

export interface CoreLabel { id: string; name: string; color: string; keyword: string; company: boolean }

let cache: Promise<CoreLabel[]> | null = null;
let subscribed = false;

/** fresh = načíst znovu (nové okno – štítek mohl přibýt jinde dřív, než dorazila událost) */
export function loadLabels(fresh = false): Promise<CoreLabel[]> {
  if (fresh) cache = null;
  if (!subscribed) {
    subscribed = true;
    events.subscribe(['core.labels'], () => { cache = null; }, {});
  }
  cache ??= core<{ labels: CoreLabel[] }>('labels', 'list').then((r) => r.labels).catch(() => { cache = null; return []; });
  return cache;
}

/** Barva štítku podle názvu (bez ohledu na velikost písmen); null = štítek v seznamu není. */
export function labelColor(list: CoreLabel[], name: string): string | null {
  const n = name.toLowerCase();
  return list.find((l) => l.name.toLowerCase() === n)?.color ?? null;
}
